export const IN_PROGRESS = 'inProgress';

export const COMPLETED = 'completed';

export const PENDING = 'pending';
